<template>
	<SkeletonScaffold primary="transparent" class="evento-item-skeleton" :class="isDarkMode ? 'evento-item-skeleton-dark' : ''">
		<div v-mBox style="height: 23px; width: 80%; margin-bottom: 0px;" />
		<div v-mBox style="height: 23px; width: 55%; margin-bottom: 0px; margin-top: 5px;" />
		<div v-mBox style="height: 15px; width: 30%; margin-bottom: 0px; margin-top: 8px;" />
		<div v-mSquare style="border-radius: 15px; margin-bottom: 14px; margin-top: 13px; width: 100%; height: auto; aspect-ratio: 7/6;" />
		<div class="evento-item-main">
			<div class="evento-item-main-left">
				<div v-mBox style="height: 20px; width: 40%; margin-bottom: 4px;" />
				<div v-mBox style="height: 16px; width: 30%; margin-bottom: 0px;" />
			</div>
			<div class="evento-item-main-right">
				<div v-mBox style="height: 10px; width: 60%; margin-bottom: 4px;" />
				<div v-mBox style="height: 26px; width: 80%; margin-bottom: 0px;" />
			</div>
		</div>
		<!-- <div v-mSquare style="width: 100%; height: 44px; margin-bottom: 0px; margin-top: 15px; border-radius: 99px;" /> -->
	</SkeletonScaffold>
</template>

<script>
	export default {
		props: ['isDarkMode']
	}
</script>

<style lang="scss">
	.evento-item-skeleton{
		width: 100%;
		padding: 20px;
		border: 1px solid #ebebeb;
		border-radius: 15px !important;

		.skeleton-card{
			width: 100%;
			height: 100%;
			padding: 0px !important;

			.skeleton-square, .skeleton-box{
				background: #ddd !important;
				border-radius: 8px !important;
				position: relative;

				&:before{
					content: "";
					position: absolute;
					width: 100%;
					height: 100%;
					-webkit-animation-duration: 1.4s !important;
					-webkit-animation-fill-mode: forwards !important;
					-webkit-animation-iteration-count: infinite !important;
					-webkit-animation-name: placeHolderShimmer !important;
					-webkit-animation-timing-function: linear !important;
					// background-image: linear-gradient(to right, #222226 0%, #313136 20%, #222226 40%, #222226 100%) !important;
					background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 60px, #ddd 80px);
					background-repeat: no-repeat !important;
					background-size: 800px 100% !important;
					border-radius: 8px !important;
				}
			}

			.skeleton-square{
				border-radius: 16px !important;
				&:before{
					border-radius: 15px !important;
					animation-delay: 0.29s !important;
				}
			}

			.evento-item-main{
				width: 100%;
				@include flex(row, space-between, center);

				.evento-item-main-left{
					width: calc(100% - 90px);
					@include flex(column, center, flex-start);
				}

				.evento-item-main-right{
					width: 90px;
					@include flex(column, center, flex-end);
				}
			}
		}

		&.evento-item-skeleton-dark{
			border: 2px solid #222226;

			.skeleton-card{
				.skeleton-square, .skeleton-box{
					background: #222226 !important;

					&::before{
						background-image: linear-gradient(to right, #222226 0%, #313136 20%, #222226 40%, #222226 100%) !important;
					}
				}
			}
		}
	}

	@-webkit-keyframes placeHolderShimmer {
		0% {
			background-position: -468px 0
		}
		100% {
			background-position: 468px 0
		}
	}

</style>